export const auth_user_gender_enum = [
  'm',
  'f',
];
